import { Link } from "react-router-dom";
import Header from "@/components/sections/Header";
import Footer from "@/components/sections/Footer";
import { PageHero } from "@/components/sections/PageHero";

const projects = [
  {
    title: "Cattle & Cattle Industries",
    image: "/images/cattle.jpeg",
    description: "Complete solutions for cattle farming and related industries including dairy equipment and cattle feed processing."
  },
  {
    title: "Milk & Milk Products",
    image: "/images/milk.jpeg",
    description: "Turnkey projects for milk processing plants, dairy products manufacturing, and cold storage facilities."
  },
  {
    title: "Agro-base Industries",
    image: "/images/agro.jpg",
    description: "Agricultural processing equipment and complete plant solutions for various agro-based industries."
  },
  {
    title: "Rubber Processing Industries",
    image: "/images/rubber.jpeg",
    description: "Rubber processing machinery and complete plant setup for rubber-based product manufacturing."
  },
  {
    title: "Industrial Projects",
    image: "/images/industrial.jpg",
    description: "Large-scale industrial project solutions with complete engineering and installation support."
  },
  {
    title: "Grape Wines and Alcohol Projects",
    image: "/images/wines.jpeg",
    description: "Complete winery setup, grape processing equipment, and alcohol distillation plants."
  },
  {
    title: "Projects on Fishery",
    image: "/images/fishery.jpeg",
    description: "Fish processing plants, cold storage, and aquaculture project solutions."
  },
  {
    title: "Projects on Poultry",
    image: "/images/poultry.jpg",
    description: "Poultry farming equipment, hatcheries, and poultry processing plant solutions."
  },
  {
    title: "Projects for Rural Women Development",
    image: "/images/rural-women.jpeg",
    description: "Small-scale industry projects designed for rural women empowerment and self-employment."
  },
  {
    title: "Solar and Renewable Energy",
    image: "/images/solar.jpeg",
    description: "Solar power plant installations and renewable energy solutions for industries."
  },
  {
    title: "Plastic Processing Industries",
    image: "/images/plastic.jpeg",
    description: "Plastic recycling and processing equipment for sustainable manufacturing."
  },
  {
    title: "Environmental and Waste Recycling",
    image: "/images/environmental.jpeg",
    description: "Waste management systems, recycling plants, and environmental protection solutions."
  },
];

export default function Projects() {
  return (
    <>
      <Header />
      <main>
        <PageHero title="Our Projects" breadcrumb="Projects" />
        
        <section className="py-[80px] bg-white">
          <div className="container mx-auto px-4 max-w-[1200px]">
            <div className="text-center mb-[50px] max-w-[800px] mx-auto">
              <h2 className="text-[28px] font-semibold text-[#001d3d] font-display uppercase tracking-wider mb-4">
                Our Business Activities
              </h2>
              <p className="text-[16px] text-[#4a5568] font-body leading-[1.6]">
                Our company has experience in project selection, design, manufacture, supply, erection, and commissioning on a turnkey basis.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {projects.map((project, index) => (
                <div 
                  key={index} 
                  className="bg-white rounded-lg overflow-hidden shadow-card card-hover border border-[#e2e8f0]"
                >
                  <div className="relative h-[220px] w-full">
                    <img
                      src={project.image}
                      alt={project.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  
                  <div className="p-6">
                    <h3 className="text-[18px] font-bold text-[#001d3d] font-display leading-[1.4] mb-3 uppercase">
                      {project.title}
                    </h3>
                    <p className="text-[#4a5568] text-[14px] leading-[1.6]">
                      {project.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-[80px] bg-[#f8f9fa]">
          <div className="container mx-auto px-4 max-w-[1200px] text-center">
            <h2 className="font-display font-bold text-[28px] text-[#001d3d] mb-6 uppercase tracking-wider">
              Interested in Our Projects?
            </h2>
            <p className="text-[#4a5568] text-[16px] mb-8 max-w-[600px] mx-auto">
              Contact us today to discuss your project requirements and get a customized solution for your business.
            </p>
            <Link 
              to="/contact" 
              className="inline-block px-10 py-4 bg-[#17A2B8] text-white font-display font-semibold uppercase tracking-wider rounded-[2px] hover:bg-[#138496] transition-colors"
            >
              Contact Us
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
